import React from 'react';
import Grid from '@mui/material/Grid';
import {CustomMaterialTable, CustomMTableToolbar} from '../../common/CustomMaterialTable';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {CustomizedSnackbars} from '../../common/snackbars';
import {DialogBoxMedium} from '../../common/dialog.medium';
import EventIcon from "@mui/icons-material/Event";
import { IconButton, InputAdornment } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { formatName } from '../../common/common';
import Tooltip from '@mui/material/Tooltip';
import Drawer from '@mui/material/Drawer';
import { withStyles } from '@mui/styles';
import FilterList from '@mui/icons-material/FilterList';
import { CustomDatePicker } from '../../common/CustomDatePicker';
import * as _R from 'ramda';

const styles = theme => ({
    drawerList: {
        width: 250,
        padding:'20px'
    },
    drawerFormControl:{
        width:'100%'
    },
    filterSubmitButton:{
        marginTop:'20px !important'
    },
    filterButton:{
        position:'absolute  !important',
        top:"0.5rem",
        right:"0.5rem",
    },
    filterResetButton:{
        marginTop:'20px !important',
        marginLeft:'10px !important'
    },
});


export const FmlaTypesComponent =  withStyles(styles)(props => {
    const { classes, ToggleDrawer } = props;
    const customButton = (props) => {
        return (<Button variant="contained" color="primary" size='small'>Add</Button>);
    }

    return(
        <React.Fragment>
        <CustomMaterialTable
        title ={"FMLA Types"}
        columns={[
            {
                title: 'Title',
                field: 'title',
            },
            {
                title: 'Description',
                field: 'description',
            },
            {
                title: 'Status',
                field: 'status',
                lookup: { 1: 'Active', 0: 'Inactive' } 
            },
            {
                title: 'Created By',
                field: 'created_by',
                render: rowData => ( formatName(rowData.cby_first_name, null, rowData.cby_last_name, props.NameFormat))
            },
            {
                title: 'Created On',
                field: 'created_on',
            },
            {
                title: 'Modified By',
                field: 'modified_by',
                render: rowData => ( formatName(rowData.mby_first_name, null, rowData.mby_last_name, props.NameFormat))
            },
            {
                title: 'Modified On',
                field: 'modified_on',
            },
        ]}
        data={props.FmlaTypes}
        options={{
            search: false,
                actionsColumnIndex: -1,
                paging: false,
                maxColumnSort: 0,
                headerStyle: { position: 'sticky', top: 0 },
                maxBodyHeight: '1000px',
        }}
        actions={[
            {
                icon: customButton,
                tooltip: 'Add FMLA Type',
                isFreeAction: true,
                onClick: (event, newData) => {
                    props.AddFmlaType();
                },
            },
            rowData => ({
                icon: 'edit',
                tooltip: 'Edit',
                onClick: (event, rowData) => {
                    props.EditFmlaType(rowData.id);
                },
            }),
        ]}
        />
        { props.Open &&
            <DialogBoxMedium
                Open = {props.Open}
                Cancel = {props.Close}
                Title = {props.Action === 'add' ? "Add FMLA type" : "Edit FMLA type"}
                OnSubmit = {(props.Action === 'edit' && parseInt(props.EditId) !== 0) ? ()=>props.OnSubmit(props.EditId) : ()=>props.OnSubmit()}
                Content = {<DialogContent FormProps={props}/>}
            />
        }
        { props.SnackbarOpen &&
            <CustomizedSnackbars
                open = {props.SnackbarOpen}
                variant= {props.SnackbarVariant}
                message = {props.SnackbarMsg}
                handleClose = {props.SnackbarClose}
            />
        }
        </React.Fragment>
    )

});


const DialogContent = (p) => { 
    const {FormProps:props} = p;
    const {FormFields, HandleDateChange} = props;
    return (
        <form className="form-fullwidth"  >
            <Grid container spacing={3} >
                <Grid item xs={12} md={6}>
                    <FormControl>
                        <TextField variant="standard"
                            id="title"
                            name="title"
                            label="Title"
                            type="text"
                            required
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={(typeof FormFields.title !== 'undefined' && FormFields.title ) ? FormFields.title : null}
                            onChange={props.HandleOnChange}
                            error={props.Errors.title && true}
                            helperText={props.Errors.title}
                        />
                    </ FormControl>
                </Grid>
                     <Grid item xs={12} md={6}>
                        <FormControl variant="standard" error={props.Errors.fmla_status && true}>
                            <InputLabel htmlFor="status" required>Status</InputLabel>
                            <Select
                                onChange={props.HandleOnChange}
                                value={_R.type(FormFields.fmla_status) !== 'Undefined' ? FormFields.fmla_status: 1}
                                inputProps={{
                                    name: 'fmla_status',
                                    id: 'fmla_status',
                                }}
                                required
                                >
                                <MenuItem value={-1} key={'status'}>--select--</MenuItem>
                                <MenuItem value={1} key={'status-1'}>Active</MenuItem>
                                <MenuItem value={0} key={'status-0'}>Inactive</MenuItem>
                            </Select>
                            <small className='error'>{typeof props.Errors !== 'undefined' && props.Errors.fmla_status && props.Errors.fmla_status}</small>
                        </ FormControl>
                    </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl>
                        <TextField
                            id="description"
                            name="description"
                            label="Description"
                            type="text"
                            multiline={true}
                            variant="outlined"
                            required
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={(typeof FormFields.description !== 'undefined') ? FormFields.description : ''}
                            onChange={props.HandleOnChange}
                            error={props.Errors.description && true}
                            helperText={props.Errors.description}
                        />
                    </ FormControl>
                </Grid>
            </Grid>
        </form>
    )
}
